export default __webpack_public_path__ + "hostpital-building.png";